import { useDispatch, useSelector } from 'react-redux';
import { useLanguage } from '../localization/useLanguage';
import { toggleTheme } from '../slice/themeSlice';
import { MoonIcon, SunIcon } from '../features/auth/AuthIcons';
import styles from './RailThemeToggle.module.scss';

/**
 * Light/dark toggle at the foot of the navigation rail.
 *
 * Shares themeSlice with the auth screens, so the choice a user makes before signing in
 * still holds afterwards.
 */
const RailThemeToggle = () => {
    const dispatch = useDispatch();
    const { t } = useLanguage();
    const theme = useSelector(state => state.themeData?.theme || 'light');

    const isDark = theme === 'dark';
    const label = isDark ? t('chat.rail.LIGHT_MODE') : t('chat.rail.DARK_MODE');

    return (
        <button
            type="button"
            className={styles.toggle}
            aria-label={label}
            title={label}
            onClick={() => dispatch(toggleTheme())}
        >
            {isDark ? <SunIcon size={19} /> : <MoonIcon size={19} />}
        </button>
    );
};

export default RailThemeToggle;
